import { LuSparkles, LuWaves, LuScissors, LuEye, LuSmile, LuScanFace, LuRuler } from 'react-icons/lu';

// Per-category icon + class descriptor for the scan-detail master/detail UI.
// Display-only (not part of the scored contract). The class label is the
// category's nature: product-driven categories read MODIFIABLE, the behavioral
// definition category reads LIFESTYLE, and bone structure reads FIXED.

export const CATEGORY_ICON = Object.freeze({
  skin_quality: LuSparkles,
  hair_scalp: LuWaves,
  facial_hair: LuScissors,
  brows_lashes: LuEye,
  mouth_smile: LuSmile,
  definition: LuScanFace,
  bone_structure: LuRuler,
});

export const CATEGORY_CLASS_LABEL = Object.freeze({
  skin_quality: 'MODIFIABLE',
  hair_scalp: 'MODIFIABLE',
  facial_hair: 'MODIFIABLE',
  brows_lashes: 'MODIFIABLE',
  mouth_smile: 'MODIFIABLE',
  definition: 'LIFESTYLE',
  bone_structure: 'FIXED',
});

export function categoryIcon(key) {
  return CATEGORY_ICON[key] || LuSparkles;
}
export function categoryClassLabel(key) {
  return CATEGORY_CLASS_LABEL[key] || 'MODIFIABLE';
}
